/* eslint-disable no-undef, react/prop-types */
import React from 'react';
import { css } from 'react-emotion';
import Img from 'gatsby-image';
import Link from 'gatsby-link';
import { Box, Flex } from '../components/Layout';
import colors from '../utils/colors';
import media from '../utils/media';

const style = css`
  text-align: center;
  padding-bottom: 10%;
  margin-top: 3.5rem;
  p {
    margin-bottom: 1em;
  }
  & ul {
    list-style-type: none;
    color: ${colors.primary};
  }
  a {
    color: ${colors.primary};
    text-decoration: underline;
    &:hover {
      text-decoration: none;
    }
  }
  h1,
  h2 {
    margin-top: 0;
    padding-bottom: 0.5em;
  }
  min-width: 33.33%;
`;

const flexStyle = css`
  margin-top: 3.5rem;
  flex-wrap: nowrap;
  flex-direction: column;
  justify-content: space-around;
  ${media.mid`
    flex-direction: row;
  `};
`;

const emptyColStyle = css`
  min-width: 33.33%;
`;

const imgStyle = css`
  margin-top: 2rem;
  margin-bottom: 1em;
  margin-right: auto;
  margin-left: auto;
  box-sizing: content-box;
  ${media.mid`
    margin-right: 1em;
  `};
`;

const outerImgWrapper = css`
  width: 8em;
  min-width: 60%;
  align-self: center;
  ${media.mid`
    min-width: 33.33%;
`};
`;

const Naytokset = ({ data }) => {
  const { hygieia } = data;
  return (
    <Box>
      <Flex className={flexStyle}>
        <div className={emptyColStyle} />
        <div className={style} color={colors.secondary}>
          <h2>Ensi-ilta</h2>
          <p>Keskiviikkona 6. kesäkuuta 2018 kello 19</p>

          <h2>Muut esitykset</h2>
          <ul>
            <li>Torstaina 7.6.2018 kello 18</li>
            <li>Perjantaina 8.6.2018 kello 18</li>
            <li>Lauantaina 9.6.2018 kello 14</li>
            <li>Lauantaina 9.6.2018 kello 18</li>
            <li>Sunnuntaina 10.6.2018 kello 13</li>
          </ul>

          <h4>Esityspaikka</h4>
          <p>
            Valvesali, Kulttuuritalo Valve
            <br />
            Hallituskatu 7, 90100 Oulu
            <br />
            <strong>
              <small>Esityksen kesto noin 1h 50 min sisältäen väliajan</small>
            </strong>
          </p>

          <Link
            href="https://www.ticketmaster.fi/search/?keyword=owla+ja+kadonnut+walkia"
            target="_blank"
            rel="noopener"
          >
            Tästä lippukauppaan
          </Link>

          <br />
          <br />
          <br />
          <h2>Kiertue</h2>

          <h3>Pispalan Sottiisi</h3>
          <p>
            Tullikamarin Pakkahuone, Tampere<br />
            Perjantaina 15. kesäkuuta 2018 kello 19
          </p>

          <h3>Kaustinen Folk Music Festival</h3>
          <p>
            Areena, Kaustinen<br />
            Lauantaina 14. heinäkuuta 2018
          </p>
        </div>
        <Img
          className={imgStyle}
          outerWrapperClassName={outerImgWrapper}
          alt="Hygieia tanssii, Kuvaaja: Inkeri Jäntti"
          sizes={hygieia.childImageSharp.sizes}
          imgStyle={{
            objectFit: 'contain',
            width: '100%',
            height: '50vh',
            boxSizing: 'content-box'
          }}
        />
      </Flex>
    </Box>
  );
};
export const query = graphql`
  query NaytoksetQuery {
    hygieia: file(relativePath: { eq: "hygieia_dance.png" }) {
      childImageSharp {
        sizes(maxWidth: 512) {
          ...GatsbyImageSharpSizes_noBase64
        }
      }
    }
  }
`;
export default Naytokset;



// WEBPACK FOOTER //
// ./src/pages/naytokset.js